module.exports = __webpack_public_path__ + "img/credit.5730a236.svg";